module.exports = __webpack_public_path__ + "static/media/ios-list.d4d689ab.svg";